<script setup lang="ts">
import { onBeforeUnmount, onMounted, useTemplateRef } from "vue";

import { injectStrict } from "@/utils/vue";

import { toggleKey } from "./injectKeys";

const props = defineProps<{ value: unknown }>();

const rootRef = useTemplateRef("root");

const toggle = injectStrict(toggleKey);

onMounted(() => toggle.register(props.value, rootRef));
onBeforeUnmount(() => toggle.unregister(props.value));
</script>

<template>
  <!-- eslint-disable-next-line vuejs-accessibility/click-events-have-key-events, vuejs-accessibility/no-static-element-interactions  -->
  <div
    ref="root"
    class="toggle-item"
    :class="{ active: toggle.active.value === value }"
    @click.stop="toggle.active.value = value"
  >
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/variables/colors";

.toggle-item {
  padding: 6px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: colors.$icon-subtle;
  position: relative;
  min-width: 32px;
  min-height: 32px;

  &.active {
    color: colors.$icon-inverse;
  }
}
</style>
